import React, { useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import PropTypes from 'prop-types';
import { X } from 'lucide-react';
import { Box, IconButton, Typography } from '@otcmarketsgroup/otcm-ui-lib';
import 'react-phone-input-2/lib/bootstrap.css';

export default function PhoneInputField ({
    value = '',
    country = 'us',
    onChange = () => {},
    disabled = false,
    error = false,
    errorText = ''
}) {
    const [isHovered, setIsHovered] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const hasErrorText = typeof errorText === 'string' && errorText.trim().length > 0;
    const hasValue = typeof value === 'string' && value.trim().length > 0;

    const onClear = () => {
        if (disabled) return;
        onChange('', { countryCode: country || 'us' });
    };

    return (
        <Box>
            <Box
                height="100%"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                sx={{
                position: 'relative',
                '.react-tel-input': {
                    height: '100%',
                    padding: '8px 0',
                    borderBottom: `1px solid ${error ? 'var(--otc-warning)' : 'var(--otc-medium-gray)'}`,
                },
                '.react-tel-input .form-control': {
                    border: 'none',
                    width: '100%',
                    height: '100%',
                    fontSize: '14px',
                    fontFamily: 'Nunito Sans',
                    padding: '0 40px 0 45px'
                },
                '.react-tel-input .selected-flag': {
                    padding: '0'
                }
            }}>
                <PhoneInput
                    value={value}
                    enableTerritories
                    country={country || 'us'}
                    preferredCountries={['us']}
                    placeholder='Phone Number'
                    countryCodeEditable
                    onChange={(phone, data) => {
                        const formattedPhone = phone ? `+${phone}` : '';
                        onChange(formattedPhone, data || { countryCode: country || 'us' });
                    }}
                    disabled={disabled}
                />
                {hasValue && !disabled && (isHovered || isFocused) && <IconButton
                    color='var(--otc-black)'
                    size='small'
                    onClick={onClear}
                    sx={{
                        position: 'absolute',
                        right: 0,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        zIndex: 1
                    }}>
                    <X />
                </IconButton>}
            </Box>
            {hasErrorText && <Typography variant='caption' sx={{ color: 'var(--otc-warning)' }}>
                {errorText}
            </Typography>}
        </Box>
    );
}

PhoneInputField.propTypes = {
    value: PropTypes.string,
    country: PropTypes.string,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    error: PropTypes.bool,
    errorText: PropTypes.string
};
